import { render, staticRenderFns } from "./EditarRessuprimento.vue?vue&type=template&id=f0e906de"
import script from "./EditarRessuprimento.vue?vue&type=script&lang=js"
export * from "./EditarRessuprimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports